module.exports = __webpack_public_path__ + "img/section-valuebuy-introduction-self.3ad83a80.png";